import { render, staticRenderFns } from "./ForgotPasswordComponentOld.vue?vue&type=template&id=8f3fdaa6&scoped=true"
import script from "./ForgotPasswordComponentOld.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordComponentOld.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f3fdaa6",
  null
  
)

export default component.exports